import React from "react";

import addFile from "assets/images/secretManagement/emptyFile.svg";

import Button from "components/Button/index";

const EmptySecret = ({ handleCreateSecret, selectedTab }) => {
  return (
    <section className="addFile">
      <div className="addFileWrapper">
        <div className="addFileContainer">
          <div className="addFileContent">
            <div className="imageWrapper">
              <img src={addFile} alt="Add File" />
            </div>
            <div className="descriptionContent">
              <h3 className="title">
                Add {selectedTab ? selectedTab : "Secrets"}
              </h3>
              <p className="content">Use the add button to add new secrets</p>
            </div>
            <div className="addButton">
              <Button
                onClick={handleCreateSecret}
                title="Add"
                showImage={true}
                type="violet"
                btnType="button"
                width="100%"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EmptySecret;
